<template>
  <div class="bg-white rounded p-1 shadow-sm">
    <h5 class="text-main text-center">
      Traffic in time
    </h5>
    <div
      class="d-flex align-items-center justify-content-center custom-height"
    >
      <vue-apex-charts
        class="responsive-chart"
        type="bar"
        height="253"
        :options="computedChartOptions"
        :series="series"
      />
      <div
        class="d-flex flex-column align-items-center justify-content-end flex-column custom-direction mb-2"
      >
        <ul class="list-style-none">
          <li
            v-for="(item,index) in totalTraffic[0].data"
            :key="index"
            class="my-5 font-size"
          >
            {{ formatBytes(item) }}
          </li>
        </ul>
      </div>

    </div>
  </div>

</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import helpers from '@/mixins/helpers'

export default {
  name: 'TrafficTime',
  components: {
    VueApexCharts,
  },
  props: {
    series: {
      type: [Array, Object],
      default: () => ([]),
    },
    timeStamps: {
      type: [Array, Object],
      default: () => ([]),
    },
    totalTraffic: {
      type: [Array, Object],
      default: () => ([]),
    },
  },
  computed: {
    tooltipFormatter() {
      return value => helpers.methods.formatBytes(value)
    },
    computedChartOptions() {
      const chartOptions = {
        chart: {
          type: 'bar',
          stacked: true,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#619AF8', '#F2A342'],
        xaxis: {
          categories: this.timeStamps,
          labels: {
            formatter: this.tooltipFormatter,
          },
        },
        yaxis: {
          labels: {
            formatter: value => (Number.isNaN(value) ? '-' : `${this.unixTimestampToDateTime(value)}`),
          },
        },
        tooltip: {
          y: {
            formatter: this.tooltipFormatter,
          },
          x: {
            formatter: value => `${this.unixTimestampToDateTime(value)}`,
          },
        },
        noData: {
          text: 'Data Unavailable: Currently, no data is being returned.',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: -15,
          style: {
            color: '#7483A1',
            fontSize: '14px',
            fontFamily: undefined,
          },
        },
      }
      return chartOptions
    },
  },
}
</script>

<style scoped>

 .responsive-chart {
   width: 90%; /* Chart will take 100% width on all screen sizes */
 }

 .custom-height {
  height: 265px;
 }

 .font-size{
  font-size: 14px;
  font-weight: 500
 }

 .list-style-none{
  list-style-type: none;
 }

 @media (min-width: 220px) {
  .responsive-chart {
      width: 100%; /* Adjust the height for larger screens (e.g., tablets) */
   }

 }

 @media (min-width: 992px) {
   .responsive-chart {
      width: 70%; /* Adjust the height for larger screens (e.g., tablets) */
   }

 }

 @media (min-width: 1200px) {
   .responsive-chart {
    width: 75%; /* Adjust the height for even larger screens (e.g., desktops) */
   }
 }

 @media (min-width: 1600px) {
   .responsive-chart {
    width: 82%; /* Adjust the height for even larger screens (e.g., desktops) */
   }
 }
</style>
